<profile-section class="pro-experiences-section">
  <ng-container slot="title" i18n> Expériences </ng-container>

  <profile-pro-experience
    class="pro-experiences-item"
    *ngFor="let experience of model || []; trackBy: trackById"
    [loading]="loadingItem?.id === experience.id"
    [model]="experience"
  ></profile-pro-experience>
</profile-section>
